import { GetStaticProps } from 'next'

import FarmbookHeader from '@/components/farmbookHeader'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import PostCard from '@/components/postCard'
import LoadingCard from '@/components/postCard/loadingCard'
import ChevronRight from '@/components/svg/ChevronRight'
import { PAGE_TYPE, STRINGS } from '@/constants/farmbook'
import useFetchPosts from '@/hooks/useFetchPosts'

export const getStaticProps = async () => {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const DeHaatWall = () => {
  const { posts, loading, hasNext, hasPrev, fetchNextPage, fetchPrevPage } =
    useFetchPosts()
  return (
    <LayoutWithNavigation>
      <section className="px-6 my-4 max-w-7xl m-auto">
        <FarmbookHeader activePage={PAGE_TYPE.DEHAAT_WALL} />
        <section className="mt-[30px] flex flex-wrap">
          {loading ? (
            Array(20)
              .fill(null)
              .map((_, i) => <LoadingCard key={i} />)
          ) : (
            <>
              {posts.map((post) => (
                <PostCard key={post.id} {...post} />
              ))}
              {posts.length === 0 ? (
                <section className="w-full text-center text-xl font-natosans-medium my-16">
                  No Blog were found matching the selected filter.
                </section>
              ) : null}
            </>
          )}
        </section>
        {(hasNext || hasPrev) && !loading ? (
          <section className="flex justify-center my-5">
            {hasPrev ? (
              <button
                className="text-base text-white bg-[#6ab41f] flex items-center px-2.5 py-1 rounded-lg mx-2.5"
                data-testid="prev-btn"
                onClick={fetchPrevPage}
              >
                <ChevronRight className="h-5 w-5 fill-white mr-1 rotate-180" />
                <span>{STRINGS.PREVIOUS}</span>
              </button>
            ) : null}
            {hasNext ? (
              <button
                className="text-base text-white bg-[#6ab41f] flex items-center px-2.5 py-1 rounded-lg mx-2.5"
                data-testid="next-btn"
                onClick={fetchNextPage}
              >
                <span>{STRINGS.NEXT}</span>
                <ChevronRight className="h-5 w-5 fill-white ml-1" />
              </button>
            ) : null}
          </section>
        ) : null}
      </section>
    </LayoutWithNavigation>
  )
}

export default DeHaatWall
